import cx from 'classnames';
import { MouseEventHandler } from 'react';

import styles from './slider.module.scss';
import { CalcPointProps, calcPoint } from './util';

interface Props extends CalcPointProps {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
}

const Mark = ({ min, max, point, label, onClick, className, disabled }: Props) => {
  return (
    <button
      type='button'
      className={cx(
        styles.mark,
        {
          [styles.min]: point === min,
          [styles.max]: point === max,
          [styles.centerX]: point !== min && point !== max,
        },
        className,
      )}
      style={{ left: calcPoint({ min, max, point }) }}
      value={point}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Mark;
